import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { OrientacaoTela } from './onboarding.telas';

@Component({
  selector: 'mg-onboarding-orientacao',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ol>
      @for (passo of orientacao().passos; track passo.titulo; let i = $index) {
        <li><span class="numero" aria-hidden="true">{{ i + 1 }}</span><div><h3>{{ passo.titulo }}</h3><p>{{ passo.texto }}</p></div></li>
      }
    </ol>
    <div class="resultado"><strong>O que conferir ao terminar</strong><p>{{ orientacao().resultado }}</p></div>
  `,
  styles: `
    :host { display: block; }
    ol { list-style: none; margin: 0; padding: 0; display: grid; gap: 1.4rem; }
    li { display: flex; align-items: flex-start; gap: .9rem; }
    .numero { flex: 0 0 26px; height: 26px; display: grid; place-items: center; border: 1px solid var(--mg-border); border-radius: 50%; color: var(--mg-text-muted); font-size: .75rem; }
    h3 { margin: .1rem 0 .4rem; font-size: 1rem; color: var(--mg-text); }
    p { margin: 0; font-size: .9375rem; line-height: 1.65; color: var(--mg-text); }
    .resultado { margin-top: 1.6rem; padding: 1.1rem 1.3rem; border-left: 3px solid var(--mg-acento); background: var(--mg-page); border-radius: 0 var(--mg-radius) var(--mg-radius) 0; }
    strong { display: block; font-size: .82rem; margin-bottom: .4rem; }
  `,
})
export class OnboardingOrientacaoComponent {
  readonly orientacao = input.required<OrientacaoTela>();
}
